import { render, staticRenderFns } from "./SearchResultItem.vue?vue&type=template&id=8f0c8812&scoped=true&"
import script from "./SearchResultItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultItem.vue?vue&type=style&index=0&id=8f0c8812&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0c8812",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
